var excelTableDashboard;
var excelTableLog;

var excelTableCheckedInLog;
var excelTableCheckedInLogElement = 'currentlycheckedingrid';

var excelTableCheckedInLogVendor;
var excelTableCheckedInLogElementVendor = 'currentlycheckedingridvendor';

var excelTableCheckedInLogEvents;
var excelTableCheckedInLogElementEvents = 'currentlycheckedingridevents';

var excelTableCheckedInLogHosts;
var excelTableCheckedInLogElementHosts = 'currentlycheckedingridhosts';

var excelTableCompleteLog;
var excelTableCompleteLogElement = 'completecheckedingrid';

var excelTableCompleteLogVendor;
var excelTableCompleteLogElementVendor = 'completecheckedingridvendor';


function GetTableData(args) {
    var result = []
    var data = excelTableDashboard.getJson(false);
    for (var i = 0; i < 500; i++) {
        var line = data[i];
        console.log(line);
        console.log(line[0]);
        if (line[0] && line[0] != "") {
            var row = { Name: line[0], Surname: line[1], Email: line[2], Phone: line[3] };
            result.push(row);
            console.log(row);
        }
    }
    return result;
}


function CreateCheckedInGridForDashboard(vendor, siteType, requiredInputs, imageUploadEnabled, type) {

    var tableHeight = window.innerHeight - 64 - 256;

    if (tableHeight < 256) {
        tableHeight = 256;
    }

    var widthForGrid = CalculateGridWidthSpace();

    var largeColumnWidth = widthForGrid * 0.12;
    var mediumColumnWidth = widthForGrid * 0.10;
    var smallColumnWidth = widthForGrid * 0.06;

    var columnWidth = widthForGrid / requiredInputs.length;
   
    var columns = [];

    if (columnWidth < 142) {
        columnWidth = 142;
    }

    requiredInputs.forEach(function (arg) {

        var columnHeaderTitle = getColumnName(arg);//arg.friendlyName;
        //If site is not gated community
        if (siteType == 1) {
            columnHeaderTitle = columnHeaderTitle.replace("Resident", "Host");
        }

        if (arg.id == "ColumnSeparator") {
            columns.push({ type: 'hidden', width: 2, title: '', name: '', readOnly: true })
        }
        else if (arg.id == "CheckinTimestamp") {
            columns.push({ type: 'text', width: 200, title: 'Check in', name: arg.id, readOnly: true })
        }
        else if (arg.id == "CheckoutTimestamp") {
            columns.push({ type: 'text', width: 200, title: 'Check out', name: arg.id, readOnly: true })
        }
        else {
            columns.push({ type: 'text', width: columnWidth, title: columnHeaderTitle, name: arg.id, readOnly: false })
        }

       
    });

    //var spectrumEditor = {
    //    // Methods
    //    closeEditor: function (cell, save) {
    //        // Get value
    //       // var value = $(cell).find('.editor').spectrum('get').toHexString();

    //        //// Set visual value
    //        //$(cell).html(value);
    //        //$(cell).css('color', value);

    //        //// Close edition
    //        //$(cell).removeClass('edition');

    //        // Save history
    //        return '<span>value</span>';
    //    },
    //    openEditor: function (cell) {
    //        //// Get current content
    //        //var html = $(cell).html();

    //        //// Create the editor
    //        //var editor = document.createElement('div');
    //        //$(cell).html(editor);
         

         
    //    },
    //    getValue: function (cell) {
    //        return $(cell).html() + '<span>hej</span>';
    //    },
    //    setValue: function (cell, value) {
    //        $(cell).html(value);
    //        $(cell).css('color', value);

    //        return true;
    //    }
    //}

    if (imageUploadEnabled) {
        columns.push({ type: 'text', width: columnWidth, title: 'Image', name: 'Image' })
    }

    if (type == 0 || type == 1 || type == 4) {
        if (vendor == 0) {
            
            excelTableCheckedInLog = jexcel(document.getElementById(excelTableCheckedInLogElement), {
                allowManualInsertColumn: false,
                allowInsertColumn: false,
                allowManualInsertRow: false,
                allowDeleteColumn: false,
                allowRenameColumn: false,
                columnDrag: false,
                search: true,
                data: null,
                columns: columns,
                tableOverflow: true,
                tableWidth: widthForGrid + "px",
                tableHeight: tableHeight + 'px',
                onload: function (instance) {

                    //$($(instance).find('.jexcel_filter')).each(function (i, obj) {
                    //    $(obj).prepend($("#dashboard-checkinlog-header-title"));
                    //});
                    $(".jexcel_search").css({ "border": "1px solid #ccc" });
                    $(".jexcel_search").css({ "margin-top": "20px" });


                },
            });


        }
        else if (vendor == 4) {

            if (excelTableCheckedInLogHosts != null) {
                excelTableCheckedInLogHosts.destroy();
            }
           
                excelTableCheckedInLogHosts = jexcel(document.getElementById(excelTableCheckedInLogElementHosts), {
                    allowManualInsertColumn: false,
                    allowInsertColumn: false,
                    allowManualInsertRow: false,
                    allowDeleteColumn: false,
                    allowRenameColumn: false,
                    columnDrag: false,
                    search: true,
                    data: null,
                    columns: columns,
                    tableOverflow: true,
                    tableWidth: widthForGrid + "px",
                    //tableWidth: '100%',
                    tableHeight: tableHeight + 'px'
                });
            
            


        }
        else {
            excelTableCheckedInLogVendor = jexcel(document.getElementById(excelTableCheckedInLogElementVendor), {
                allowManualInsertColumn: false,
                allowInsertColumn: false,
                allowManualInsertRow: false,
                allowDeleteColumn: false,
                allowRenameColumn: false,
                columnDrag: false,
                search: true,
                data: null,
                columns: columns,
                tableOverflow: true,
                tableWidth: widthForGrid + "px",
                //tableWidth: '100%',
                tableHeight: tableHeight + 'px'
            });
        }
    }
    else if (type == 5 && vendor == 5) {

        var columnLength = columns.length;
        for (var x = 0; x < columnLength; x++) {
            if (columns[x].name == "CheckinTimestamp") {
                columns[x].title = "Time";
            }

            if (columns[x].name == "ExpectedCheckinTimestamp") {
                columns[x].title = "Start";
            }

            if (columns[x].name == "ExpectedCheckoutTimestamp") {
                columns[x].title = "End";
            }
        }

        if (excelTableCheckedInLogEvents != null) {
            excelTableCheckedInLogEvents.destroy();
        }


        excelTableCheckedInLogEvents = jexcel(document.getElementById(excelTableCheckedInLogElementEvents), {
            allowManualInsertColumn: false,
            allowInsertColumn: false,
            allowManualInsertRow: false,
            allowDeleteColumn: false,
            allowRenameColumn: false,
            columnDrag: false,
            search: true,
            filters: true,
            data: null,
            columns: columns,
            tableOverflow: true,
            tableWidth: widthForGrid + "px",
            tableHeight: tableHeight + 'px',
            onload: function (instance) {

                //$($(instance).find('.jexcel_filter')).each(function (i, obj) {
                //    $(obj).prepend($("#dashboard-checkinlog-header-title"));
                //});
                $(".jexcel_search").css({ "border": "1px solid #ccc" });
                $(".jexcel_search").css({ "margin-top": "20px" });


             


            },
            onchange: function (obj, cel, val) {

               
                try {
                    document.getElementById('events-filtered-count').innerHTML = val;
                }
                catch (e) { }
            }
        });

    }

    


    //setTimeout(function () {
    //    showGuardOnDutyColumn(0, false);
    //}, 250);
   
}

function RefreshCheckedInGridForDashboard(vendor, checkinData) {
    try {
        if (vendor == 0) {
            if (excelTableCheckedInLog != null) {
                excelTableCheckedInLog.setData(checkinData, false);
                return 1;
            } else {
                return 0;
            }
        }
        else if (vendor == 1){
            if (excelTableCheckedInLogVendor != null) {
                excelTableCheckedInLogVendor.setData(checkinData, false);
                return 1;
            } else {
                return 0;
            }
        }
        else if (vendor == 4) {
            if (excelTableCheckedInLogHosts != null) {
                excelTableCheckedInLogHosts.setData(checkinData, false);
                return 1;
            } else {
                return 0;
            }
        }
        else if (vendor == 5) {
            if (excelTableCheckedInLogEvents != null) {
                excelTableCheckedInLogEvents.setData(checkinData, false);
                return 1;
            } else {
                return 0;
            }
        }
    } catch (e) {
        console.log("RefreshCheckedInGridForDashboard Error");
        console.log(e);
    }
   
}

function RefreshCompleteGridForDashboard(vendor, checkinData) {
    try {
        if (vendor == 0) {
            if (excelTableCompleteLog != null) {
                excelTableCompleteLog.setData(checkinData, false);
                return 1;
            } else {
                return 0;
            }
        } else {
            if (excelTableCompleteLogVendor != null) {
                excelTableCompleteLogVendor.setData(checkinData, false);
                return 1;
            } else {
                return 0;
            }
        }
    } catch (e) {
        console.log("RefreshCompleteGridForDashboard Error");
        console.log(e);
    }
   
}


function CreateCompleteCheckedInGridForDashboard(vendor, siteType, requiredInputs, imageUploadEnabled, type) {

    var tableHeight = window.innerHeight - 64 - 256;

    if (tableHeight < 256) {
        tableHeight = 256;
    }

    var columns = [];

    var widthForGrid = CalculateGridWidthSpace();

    var largeColumnWidth = widthForGrid * 0.12;
    var mediumColumnWidth = widthForGrid * 0.10;
    var smallColumnWidth = widthForGrid * 0.06;

    var columnWidth = widthForGrid / requiredInputs.length;

    if (columnWidth < 142) {
        columnWidth = 142;
    }


    requiredInputs.forEach(function (arg) {

        var columnHeaderTitle = getColumnName(arg);//arg.friendlyName;
        //If site is not gated community
        if (siteType == 1) {
            columnHeaderTitle = columnHeaderTitle.replace("Resident", "Host");
        }

        if (arg.id == "ColumnSeparator") {
            columns.push({ type: 'hidden', width: 2, title: '', name: '', readOnly: true })
        }
        else if (arg.id == "CheckinTimestamp") {
            columns.push({ type: 'text', width: 200, title: 'Check in', name: arg.id, readOnly: true })
        }
        else if (arg.id == "CheckoutTimestamp") {
            columns.push({ type: 'text', width: 200, title: 'Check out', name: arg.id, readOnly: true })
        }
        else {
            columns.push({ type: 'text', width: columnWidth, title: columnHeaderTitle, name: arg.id, readOnly: false })
        }

    });

    if (imageUploadEnabled) {
        columns.push({ type: 'text', width: columnWidth, title: 'Image', name: 'Image' })
    }

    if (type == 0 || type == 1) {

   
    if (vendor == 0) {
        excelTableCompleteLog = jexcel(document.getElementById(excelTableCompleteLogElement), {
            allowManualInsertColumn: false,
            allowInsertColumn: false,
            allowDeleteColumn: false,
            allowRenameColumn: false,
            columnDrag: false,
            data: null,
            columns: columns,
            tableOverflow: true,
            tableWidth: widthForGrid + "px",
            tableHeight: tableHeight + 'px'
        });
    } else {
        excelTableCompleteLogVendor = jexcel(document.getElementById(excelTableCompleteLogElementVendor), {
            allowManualInsertColumn: false,
            allowInsertColumn: false,
            allowDeleteColumn: false,
            allowRenameColumn: false,
            columnDrag: false,
            data: null,
            columns: columns,
            tableOverflow: true,
            tableWidth: widthForGrid + "px",
            tableHeight: tableHeight + 'px'
        });
        }
    }
   

}

function CalculateGridWidthSpace() {
    var width = screen.width;
    //var width = vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    console.log(width);

    //var sidebarWidth = $(".sidebar").width();
    //console.log(sidebarWidth);

    var sidebarWidth = 250;

    ////Mobile case
    //if (sidebarWidth == width) {
    //    sidebarWidth = 0;
    //}

    var widthForGrid = width - sidebarWidth - 90; //24px is page padding
    return widthForGrid;
}


//Dashboard Date range pickers start

var dashboardCheckinDateRangePickerElementId = 'dashboardCheckinDateRangePicker';
var dashboardCheckinDateRangePickerStartSelected = '';
var dashboardCheckinDateRangePickerEndSelected = '';

var dashboardCheckoutDateRangePickerElementId = 'dashboardCheckoutDateRangePicker';
var dashboardCheckoutDateRangePickerStartSelected = '';
var dashboardCheckoutDateRangePickerEndSelected = '';

function buildDashboardsDateRangePickers() {
    $(document).ready(function () {
        $('#' + dashboardCheckinDateRangePickerElementId).daterangepicker(null, function (start, end, label) {
            dashboardCheckinDateRangePickerStartSelected = start.toISOString();
            dashboardCheckinDateRangePickerEndSelected = end.toISOString();

            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnChangeCheckedInTimePeriodFromDateRange');
        });

        $('#' + dashboardCheckoutDateRangePickerElementId).daterangepicker(null, function (start, end, label) {
            dashboardCheckoutDateRangePickerStartSelected = start.toISOString();
            dashboardCheckoutDateRangePickerEndSelected = end.toISOString();

            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnChangeCheckedOutTimePeriodFromDateRange');
        });
    });
}

function getDashboardCheckinDateRangePickerStartSelected() {
    return dashboardCheckinDateRangePickerStartSelected;
}
function getDashboardCheckinDateRangePickerEndSelected() {
    return dashboardCheckinDateRangePickerEndSelected;
}

function getDashboardCheckoutDateRangePickerStartSelected() {
    return dashboardCheckoutDateRangePickerStartSelected;
}
function getDashboardCheckoutDateRangePickerEndSelected() {
    return dashboardCheckoutDateRangePickerEndSelected;
}

// Dashboard Date range pickers end


function checkoutCurrentGridConfirm(vendor, visitorCountToBeCheckedOut) {

    var visitorTitle = visitorCountToBeCheckedOut == 1 ? "visitor" : "visitors";

    if (vendor == 1) {
        visitorTitle = visitorCountToBeCheckedOut == 1 ? "vendor" : "vendors";
    }

    swal({
        title: "Are you sure?",
        text: visitorCountToBeCheckedOut + " " + visitorTitle + " currently shown in the check in list will be checked out",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-success",
        confirmButtonText: "Yes, check out.",
        closeOnConfirm: false
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnCheckoutCurrentGridConfirmed');
            swal("Checked out.", visitorCountToBeCheckedOut + " " + visitorTitle + " checked out", "success");

        });
}

function checkoutAllConfirm(vendor, siteName) {

    var visitorTitle = "visitors";
    if (vendor == 1) {
        visitorTitle = "vendors";
    }

    swal({
        title: "Are you sure?",
        text: "All " + visitorTitle + " in " + siteName + " will be checked out.",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-success",
        confirmButtonText: "Yes, check out.",
        closeOnConfirm: false
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnCheckoutAllConfirmed');
            swal("Checked out.", "All " + visitorTitle + " in " + siteName + " checked out", "success");

        });

}

function CalculateWidthForVisitTimeline() {


    var visitTimelineBaseHolderWidth = $("#visitTimelineBaseHolder").width();
    console.log("visitTimelineBaseHolderWidth");
    console.log(visitTimelineBaseHolderWidth);

    return visitTimelineBaseHolderWidth;
}


var tippyInstancesDashboard = [];


function createTimelineVisitTooltip(el, text) {
   
    setTimeout(function () {
        var tippyInstance = tippy('#' + el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });

        tippyInstancesDashboard.push(tippyInstance);
    }, 1500);

    
}

function clearTippyInstancesDashboard() {
    var tippyInstancesCount = 0;
    if (tippyInstancesDashboard != null) {
        tippyInstancesCount = tippyInstancesDashboard.length;

      

        for (var i = 0; i < tippyInstancesCount; i++) {

            try {
                tippyInstancesDashboard[i].hide();
            } catch (e) {

            }


            try {
                tippyInstancesDashboard[i].disable();
            } catch (e) {

            }


            try {
                tippyInstancesDashboard[i].destroy();
            } catch (e) {

            }
        }

        tippyInstancesDashboard = [];
    }

    console.log("Cleared tippy instances Dashboard");

}


function showGuardOnDutyColumn(gridIndex, visible) {

    var guardNameColNumber = 1;

    //if (gridIndex == 0) {
    //    if (visible) {
    //        excelTableCheckedInLog.showColumn(guardNameColNumber);
    //    } else {
    //        excelTableCheckedInLog.hideColumn(guardNameColNumber);
    //    }
    //}
    //else if (gridIndex == 1) {
    //    if (visible) {
    //        excelTableCheckedInLogVendor.showColumn(guardNameColNumber);
    //    } else {
    //        excelTableCheckedInLogVendor.hideColumn(guardNameColNumber);
    //    }
    //}

    try {
        if (visible) {
            excelTableCheckedInLog.showColumn(guardNameColNumber);
            excelTableCheckedInLogVendor.showColumn(guardNameColNumber);
        } else {
            excelTableCheckedInLog.hideColumn(guardNameColNumber);
            excelTableCheckedInLogVendor.hideColumn(guardNameColNumber);
        }
    } catch (e) {

    }
       
   
    //alert(visible);
}

function dashboardDisplayImage(checkinId, blobIdentifier) {
    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnDashboardShowPhotoOpenedByUser', checkinId, blobIdentifier);
}


function openDashboardDisplayCheckinImageModal(arg) {
    $('#dashboardShowPhotoModal').modal();
}